<template>
  <b-modal
    id="unlockUser"
    size="sm"
    ref="unlockUserModal"
    class="modal-backdrop"
    no-close-on-esc
    no-close-on-backdrop
  >
    <template slot="modal-header" class="mx-auto">
      <h5 class="modal-title">Unlock User</h5>
    </template>
    <template slot="default">
      <p>Unlocking the user will allow the user to retry logging into applications as long as they are enabled.</p>
    </template>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button class="um-btn" @click="unlockUser()">Unlock</b-button>
      <b-button class="um-btn" @click="cancelChanges()">Cancel</b-button>
    </template>
    <loading :active.sync="isLoading" :can-cancel="true" :is-full-page="fullPage"></loading>
  </b-modal>
</template>

<script>
import service from "../../services/api.services";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "UserUnlock",
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      fullPage: true
    };
  },
  props: {
      username: String,
      userDetail:Object
  },
  methods: {
    cancelChanges: function() {
      this.$refs["unlockUserModal"].hide();
    },
    async unlockUser() {
      this.isLoading = true;
        var that = this;
        await service.UnlockUser(that.userDetail)
        .then(response => {
          if (response.data.isUnlocked) {
            that.isLoading = false;
            this.$emit("onUserUnlock", true);
            this.$refs["unlockUserModal"].hide();
          }
        })
        .catch(error => {
          if (error) {
            that.isLoading = false;
            this.$emit("onUserUnlock", false);
          }
        });
    }
  }
};
</script>